module.exports = __webpack_public_path__ + "static/media/product_scale.425cf014.svg";